import { EnumOption } from "./enum-option"

export const MailRecipientType = {
    GIP: 0,
    Company: 1,
    FN: 2,
    Sponsor: 3,
}

export const MailRecipientTypeList: EnumOption[] = [
    { value: MailRecipientType.GIP, label: 'GIP' },
    { value: MailRecipientType.Company, label: 'Company User' },
    { value: MailRecipientType.FN, label: 'FN Contacts' },
    { value: MailRecipientType.Sponsor, label: 'Sponsor' }
]
